module.exports = __webpack_public_path__ + "img/ETHEREUM.6594b16f.png";